const userProfileTeamMembers = {
  en: {
    emptyUsers: "No registered user at the moment.",
    register: "Register",
    details: "Details",
    newUserButton: "New User",
    submitButton: "Save user",
    editButton: "Edit User",
    deleteButton: "Remove user",
    titleRegisterForm: "Profile",
    subtitleRegisterForm:
      "This information will be displayed publicly so be careful what you share.",
    picture: "Picture",
    pictureChangeButton: "Change",
    pictureRemoveButton: "Remove picture",
    firstName: "First name",
    inputPlaceholderFirstName: "Insert first name",
    fullName: "Full name",
    lastName: "Last name",
    inputPlaceholderLastName: "Insert last name",
    status: "Status",
    statusActive: "Active",
    statusInactive: "Inactive",
    inputPlaceholderStatus: "Select status",
    emailAddress: "Email address",
    inputPlaceholderEmailAddress: "Insert the company mail",
    profile: "Profile",
    inputPlaceholderProfile: "Select profile",
    phoneNumber: "Phone number",
    inputPlaceholderPhoneNumber: "Insert phone number",
    country: "Country",
    inputPlaceholderCountry: "Select country",
    language: "Language",
    titleDeleteUser: "Do you really want to delete that user?",
    textDeleteUser: "Please, confirme the action",
    lastActive: "Last active",
    chooseFile: "Change",
    noFileChosen: "No file Chosen",
    systemClock: {
      inputLabel: "System Clock",
      useComputerTimeZone: "Use my computer clock as time zone"
    },
    clientAccess: "Client Access"
  },
  pt: {
    emptyUsers: "Nenhum usuário cadastrado até o momento.",
    register: "Cadastro",
    details: "Detalhes",
    newUserButton: "Novo Usuário",
    submitButton: "Salvar usuário",
    editButton: "Editar Usuário",
    deleteButton: "Excluir usuário",
    titleRegisterForm: "Perfil",
    subtitleRegisterForm:
      "Estas informações serão exibidas publicamente, portanto tenha cuidado com o que você compartilha.",
    picture: "Imagem",
    pictureChangeButton: "Alterar",
    pictureRemoveButton: "Remover imagem",
    firstName: "Primeiro nome",
    inputPlaceholderFirstName: "Inserir primeiro nome",
    fullName: "Nome Completo",
    lastName: "Último nome",
    inputPlaceholderLastName: "Inserir último nome",
    status: "Status",
    statusActive: "Ativo",
    statusInactive: "Inativo",
    inputPlaceholderStatus: "Selecione o status",
    emailAddress: "Endereço de email",
    inputPlaceholderEmailAddress: "Inserir email corporativo",
    profile: "Perfil",
    inputPlaceholderProfile: "Selecione o perfil",
    phoneNumber: "Número de telefone",
    inputPlaceholderPhoneNumber: "Inserir número de telefone",
    country: "País",
    inputPlaceholderCountry: "Selecione o país",
    language: "Idioma",
    titleDeleteUser: "Você realmente quer excluir esse usuário?",
    textDeleteUser: "Por favor, confirme a ação",
    lastActive: "Ativo em",
    chooseFile: "Mudar",
    noFileChosen: "Nenhum arquivo selecionado",
    systemClock: {
      inputLabel: "Relógio do sistema",
      useComputerTimeZone: "Usar o relógio do meu computador como fuso horário"
    },
    clientAccess: "Acesso do cliente"
  },
  es: {
    emptyUsers: "Ningún usuario registrado en este momento.",
    register: "Registro",
    details: "Detalles",
    newUserButton: "Nuevo Usuario",
    submitButton: "Guardar usuario",
    editButton: "Editar Usuario",
    deleteButton: "Eliminar usuario",
    titleRegisterForm: "Perfil",
    subtitleRegisterForm:
      "Esta información se mostrará públicamente, así que ten cuidado con lo que compartes.",
    picture: "Imagen",
    pictureChangeButton: "Cambiar",
    pictureRemoveButton: "Eliminar imagen",
    firstName: "Nombre",
    inputPlaceholderFirstName: "Insertar el nombre",
    fullName: "Nombre Completo",
    lastName: "Apellido",
    inputPlaceholderLastName: "Insertar el apellido",
    status: "Estado",
    statusActive: "Activado",
    statusInactive: "Inactivado",
    inputPlaceholderStatus: "Seleccione el estado",
    emailAddress: "Correo electrónico",
    inputPlaceholderEmailAddress: "Insertar el correo de la empresa",
    profile: "Perfil",
    inputPlaceholderProfile: "Seleccione el perfil",
    phoneNumber: "Número de teléfono",
    inputPlaceholderPhoneNumber: "Insertar número de teléfono",
    country: "País",
    inputPlaceholderCountry: "Seleccione el país",
    language: "Idioma",
    titleDeleteUser: "¿Realmente quieres borrar ese usuario",
    textDeleteUser: "Por favor, confirme la acción",
    lastActive: "Activo em",
    chooseFile: "Cambio",
    noFileChosen: "No hay archivo seleccionado",
    systemClock: {
      inputLabel: "Reloj del sistema",
      useComputerTimeZone: "Utilizar el reloj de mi ordenador como huso horario"
    },
    clientAccess: "Acceso de los clientes"
  }
}

export default userProfileTeamMembers
